export default __webpack_public_path__ + "static/media/Venturer's Boots of the Roaring Jungle.d8430f3a.jpg";